const SPECIFIC_NEX_TO_COMMON_COIN_MAP = {
    USDTERC: 'USDT',
    USDTSOL: 'USDT',
    USDTTRX: 'USDT',
    USDTAVAX: 'USDT',
    USDTBSC: 'USDT',
    USDTARB: 'USDT',
    USDTOP: 'USDT',
    USDTMATIC: 'USDT',
    USDTPOL: 'USDT',
    USDCMATIC: 'USDC',
    USDCBSC: 'USDC',
    USDCTRX: 'USDC',
    USDCAVAX: 'USDC',
    USDCSOL: 'USDC',
    USDCARB: 'USDC',
    USDCOP: 'USDC',
    USDCPOL: 'USDC',
    AVAXC: 'AVAX',
    MBOXBSC: 'MBOX',
    BUSDBSC: 'BUSD',
    MATICNATIVE: 'MATIC',
    NEARBSC: 'NEAR',
    ADABSC: 'ADA',
    WBTC: 'BTC',
    ARBETH: 'ETH',
    OPETH: 'ETH',
    WETH: 'ETH',
    INJBSC: 'INJ',
    USDCALGO: 'USDC',
    ETHBSC: 'ETH',
    AVAXBSC: 'AVAX',
    FTMNATIVE: 'FTM',
    POLERC: 'POL',
}

const COMMON_COIN_TO_NEX_MAP = {
    USDT: ['USDTERC', 'USDTTRX', 'USDTSOL', 'USDTAVAX', 'USDTMATIC', 'USDTBSC', 'USDTARB', 'USDTOP', 'USDTPOL'],
    USDC: ['USDCMATIC', 'USDCBSC', 'USDCTRX', 'USDCAVAX', 'USDCSOL', 'USDCARB', 'USDCOP', 'USDCALGO', 'USDCPOL'],
    MBOX: ['MBOXBSC'],
    BUSD: ['BUSDBSC'],
    MATIC: ['MATIC', 'MATICNATIVE'],
    NEAR: ['NEARBSC'],
    ADA: ['ADA', 'ADABSC'],
    AVAX: ['AVAXC', 'AVAXBSC'],
    ETH: ['ETH','ARBETH', 'WETH', 'OPETH', 'ETHBSC'],
    INJ: ['INJBSC'],
    FTM: ['FTMNATIVE'],
    POL: ['POLERC'],
}

const COMMON_COIN_CODE_NAME_RECORD = {
    USDT: 'Tether',
    AVAX: 'Avalanche',
}

const mapNexCoinCodeToCommonCoinCode = (nexCoinCode: string): string =>
    SPECIFIC_NEX_TO_COMMON_COIN_MAP[nexCoinCode] ?? nexCoinCode

const mapCommonCoinCodeToNexCoinCodeList = (commonCoinCode: string): string[] =>
    COMMON_COIN_TO_NEX_MAP[commonCoinCode] ?? [commonCoinCode]

export {
    SPECIFIC_NEX_TO_COMMON_COIN_MAP,
    COMMON_COIN_TO_NEX_MAP,
    COMMON_COIN_CODE_NAME_RECORD,
    mapCommonCoinCodeToNexCoinCodeList,
    mapNexCoinCodeToCommonCoinCode,
}
